import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WdxListDelimiter } from '../models/wdx-list-delimiter.type';

@Component({
    selector: 'wdx-list',
    templateUrl: './wdx-list.component.html',
    styleUrls: ['./wdx-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
    host: {
        role: 'ul',
        '[class.wdx-list--horizontal]': 'horizontalClass',
        '[class.wdx-list--vertical]': 'verticalClass',
        '[class.wdx-list--pipe]': 'pipeDelimiterClass',
    },
})
export class WdxListComponent {
    @Input() set vertical(isVertical: boolean) {
        this.horizontalClass = !isVertical;
        this.verticalClass = isVertical;
    }
    @Input() set delimiter(delimiter: WdxListDelimiter) {
        this.pipeDelimiterClass = delimiter === 'pipe';
    }
    horizontalClass = true;
    verticalClass = false;
    pipeDelimiterClass = false;
}
